import css from 'styled-jsx/css';

const styles = css.global`#rastreadores-banner {
  z-index: 2;
  position: inherit;
}

#rastreadores-banner .ctn {
  position: relative;
  padding: 0;
}

.text-container {
  position: absolute;
  left: calc(50% - 110px);
  top: 60px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-align: center;
  max-width: 220px;
  color: #ffffff;
}

.text-container .text-title {
  font-family: SantanderHeadline;
  font-size: 32px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: 0px;
}

.text-container .text-description {
  font-family: SantanderHeadline;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0px;
}

.img-container {
  display: flex;
  height: 515px;
}

.img-container h1 {
  display: flex;
  width: 100%;
}
.img-container img {
  object-fit: cover;
  width: 100%;
  height: 503px;
}

@media (min-width: 992px) {
  #rastreadores-banner {
    background-image: linear-gradient(180deg, #990000 70%, #ffffff00 70%);
  }

  .text-container {
    position: absolute;
    right: 86px;
    left: auto;
    top: 88px;
  max-width: 333px;
}

  .img-container {
    height: 410px;
  }

  .img-container img {
    width: 100%;
    height: 410px;
    margin: 0 auto;
    object-fit: contain;
    object-position: top;
  }
}

@media (min-width: 1400px) {
  #rastreadores-banner {
    background-image: linear-gradient(180deg, #990000 80%, #ffffff00 80%);
  }
}
`;

export default styles;